/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Ota_Bundle_EmbeddedInputs */

const en_mobile_ota_bundle_embedded = /** @type {(inputs: Mobile_Ota_Bundle_EmbeddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embedded (store build)`)
};

const es_mobile_ota_bundle_embedded = /** @type {(inputs: Mobile_Ota_Bundle_EmbeddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrado (build de tienda)`)
};

/**
* | output |
* | --- |
* | "Embedded (store build)" |
*
* @param {Mobile_Ota_Bundle_EmbeddedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_ota_bundle_embedded = /** @type {((inputs?: Mobile_Ota_Bundle_EmbeddedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Ota_Bundle_EmbeddedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_ota_bundle_embedded(inputs)
	return en_mobile_ota_bundle_embedded(inputs)
});